import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthenticationService} from "../../auth/services/authentication.service";
import {AdminService} from "../services/admin.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-admin-profile',
  standalone: false,
  templateUrl: './admin-profile.component.html',
  styleUrl: './admin-profile.component.scss'
})
export class AdminProfileComponent implements OnInit {
  profileForm!: FormGroup;
  userId: string | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private service: AdminService
  ) {
  }

  ngOnInit(): void {
    const user = this.authService.currentUserValue;
    if (!user) {
      Swal.fire('Error', 'User not authenticated', 'error');
      return;
    }

    this.userId = user.id;
    this.profileForm = this.fb.group({
      fullName: [user.fullName, Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
      email: [{value: user.email, disabled: true}],
      role: [{value: user.roles.join(', '), disabled: true}]
    });
  }

  onSubmit(): void {
    if (this.profileForm.invalid || !this.userId) return;

    const updateModel = {
      fullName: this.profileForm.get('fullName')?.value,
      email: this.profileForm.get('email')?.value,
      password: this.profileForm.get('password')?.value,
      role: this.profileForm.get('role')?.value.split(',').map((r: string) => r.trim())
    };

    this.service.updateUser(this.userId, updateModel).subscribe({
      next: () => Swal.fire('Success', 'Profile updated successfully!', 'success'),
      error: () => Swal.fire('Error', 'Failed to update profile', 'error')
    });
  }
}
